function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { DatalayerScene, Datalayer } from '@finect/front-gtm';
import { FundGettingStarted, FundComparison } from '@finect/tabular-components/Modules';
import { withTheme } from 'styled-components';
import { v4 as uuidv4 } from 'uuid';
import { Container } from '@finect/tabular-core/Container';
import { ContainerInner } from '@finect/tabular-core/ContainerInner';
import { MainContent } from '@finect/tabular-core/MainContent';
import { Applications } from '@finect/front-applications';
import { getFundMainClass, getProductTypeLabel, getProductTypeBySlug, getFundsComparisonPath } from '@finect/front-resources/Products';
import { withParams } from '@finect/front-core/withParams';
import { Head } from '@finect/tabular-components/Head';
import { getFund, clearFunds, removeProduct, fetchUserComparisons, setUserComparisonsDialog, fetchFunds, fetchInitialData } from '../commons/store/comparison/actions';
import { gettingStarted } from '../commons/IIC/gettingStarted';
import { withContext } from '../commons/hocs';
import { FamilyInsideNavigation } from '../commons/IIC/components';
const mapStateToProps = state => ({
  user: state.user.user,
  funds: state.comparison.funds,
  dialog: state.comparison.dialog,
  showDialog: state.comparison.dialog.open,
  userComparisons: state.comparison.userComparisons,
  comparisonsDialog: state.comparison.comparisonsDialog
});
const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators({
    getFund,
    clearFunds,
    removeProduct,
    fetchUserComparisons,
    setUserComparisonsDialog,
    fetchFunds,
    fetchInitialData
  }, dispatch)
});
class Comparison extends React.Component {
  constructor() {
    super(...arguments);
    _defineProperty(this, "applications", new Applications('products-comparison'));
    _defineProperty(this, "state", {
      uuid: null
    });
    _defineProperty(this, "setUuid", () => {
      this.setState({
        uuid: uuidv4().replace(/-/g, '')
      });
    });
    _defineProperty(this, "getPath", () => {
      const {
        contextProps
      } = this.props;
      const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
      const isins = this.props.funds.map(item => item.isin);
      const contextString = contextProps.context.length ? `${contextProps.context.filter(el => el.id !== 'producto').map(cont => `${cont.id}=${cont.model.alias}`).join('&')}` : '';
      const params = [];
      isins.length && params.push(`products=${isins.join(',')}`);
      contextString && params.push(contextString);
      return `${getFundsComparisonPath(this.props.theme, productType)}${params.length ? `?` : ''}${params.join('&')}`;
    });
    _defineProperty(this, "addProductsToComparison", products => {
      const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
      this.props.actions.fetchFunds(productType, products);
    });
    _defineProperty(this, "handleRemoveProduct", product => {
      this.props.actions.removeProduct(product);
    });
    _defineProperty(this, "handleAddProduct", (productType, product) => {
      this.props.actions.getFund(productType, product.id);
    });
    _defineProperty(this, "handleApplicationAddedFund", id => {
      const ids = this.props.funds.map(fund => fund.id);
      const newIds = !ids.includes(id) ? [...ids, id] : [...ids];
      this.applications.setFieldValue('products', newIds, null).setStatus('uncompleted').send();
    });
    _defineProperty(this, "handleSelectSession", session => {
      const fundsField = session.items.find(item => item.field === 'products');
      const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
      this.applications.sessionID = session.id;
      this.applications.setStatus('completed');
      this.props.actions.clearFunds();
      this.props.actions.setUserComparisonsDialog(false);
      this.props.actions.fetchFunds(productType, fundsField.value);
    });
    _defineProperty(this, "handleOpenUserComparisonsDialog", () => {
      this.props.actions.setUserComparisonsDialog(true);
    });
    _defineProperty(this, "handleCloseUserComparisonsDialog", () => {
      this.props.actions.setUserComparisonsDialog(false);
    });
    _defineProperty(this, "handleSaveSearch", () => {
      this.applications.setStatus('completed').send();
    });
  }
  static loadInitialData(store, cookies, match, params) {
    const productType = getProductTypeBySlug(match.params.typeSlug);
    const products = params.products ? params.products.split(',') : [];
    return store.dispatch(fetchInitialData(cookies, productType, products));
  }
  componentWillUnmount() {
    this.props.actions.clearFunds();
  }
  componentDidMount() {
    window && window.scrollTo(0, 0);
    const {
      uuid
    } = this.state;
    const {
      params
    } = this.props;
    const products = params && params.products ? params.products.split(',') : [];
    if (!uuid) {
      this.setUuid();
    }
    if (products.length && !this.props.funds.length) {
      this.addProductsToComparison(products.slice(0, 6));
    }
    if (!this.props.funds.length) {
      this.props.actions.clearFunds();
    }
    if (this.props.funds.length > 1) {
      const ids = this.props.funds.map(fund => fund.id);
      const names = this.props.funds.map(fund => getFundMainClass(fund)).filter(fundClass => Boolean(fundClass)).map(fundClass => fundClass.name);
      this.applications.setFieldValue('productsCompared', names.join(' vs '), null).setFieldValue('products', ids, null).setStatus('uncompleted').send();
    }
    if (!this.props.userComparisons.fetched) this.props.actions.fetchUserComparisons();
  }
  componentDidUpdate(prevProps) {
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    const {
      funds
    } = this.props;
    if (!this.props.funds.length) {
      this.setUuid();
    }
    if (prevProps.funds.length !== funds.length && funds.length > 1) {
      window && history.pushState('', `Comparador de ${getProductTypeLabel(productType, 'plural', 'lowercase')}`, this.getPath());
      const ids = funds.map(fund => fund.id);
      const names = funds.map(fund => getFundMainClass(fund)).filter(fundClass => Boolean(fundClass)).map(fundClass => fundClass.name);
      this.applications.setFieldValue('productsCompared', names.join(' vs '), null).setFieldValue('products', ids, null).send();
    }
  }
  shouldComponentUpdate(nextProps, nextState) {
    if (nextState.uuid !== this.state.uuid) {
      return false;
    }
    return true;
  }
  render() {
    const productType = getProductTypeBySlug(this.props.match.params.typeSlug);
    const {
      funds,
      userComparisons,
      comparisonsDialog,
      contextProps,
      getContextModelPath,
      getContextModelName,
      params,
      theme
    } = this.props;
    const {
      uuid
    } = this.state;
    const names = funds.map(fund => getFundMainClass(fund)).filter(fundClass => Boolean(fundClass)).map(fundClass => fundClass.name);
    const shareImageUrl = `https://www.finect.com/image/daa45cf1e7eb4f466dbca66a48545657f5208990776`;
    const shareUrl = `https://${process.env.FINECT_BASEURL || 'www.finect.com'}${this.getPath()}`;
    const twitterCardType = 'summary_large_image';
    const shareTitle = names.length && names.length < 3 ? `📊🔍 ¿Qué fondo de inversión es mejor? ¿El ${names.join(' o el ')}? He utilizado el comparador de @finect y me ha salido esto` : '📊🔍 ¿Qué fondo de inversión es mejor? He utilizado el comparador de @finect con varios fondos y me ha salido esto';
    const contextOrdered = Object.keys(params).map(key => contextProps.context.find(item => item.id === key)).filter(element => element);
    const contextStorefront = contextProps.context.find(cont => cont.id === 'escaparate');
    return React.createElement(React.Fragment, null, React.createElement(Head, {
      title: `Comparador de ${getProductTypeLabel(productType, 'plural', 'lowercase')}`,
      description: `Comparador de ${productType.plural}`
    }, this.props.funds.length ? React.createElement("meta", {
      name: "robots",
      content: "noindex"
    }) : null, React.createElement("meta", {
      property: "og:image",
      content: shareImageUrl
    }), React.createElement("meta", {
      property: "og:site_name",
      content: "Finect"
    }), React.createElement("meta", {
      property: "og:title",
      content: shareTitle
    }), React.createElement("meta", {
      name: "twitter:card",
      content: twitterCardType
    }), React.createElement("meta", {
      name: "twitter:site",
      content: "@finect"
    }), React.createElement("meta", {
      name: "twitter:title",
      content: shareTitle
    }), React.createElement("meta", {
      name: "twitter:image",
      content: shareImageUrl
    })), React.createElement(DatalayerScene, {
      pageType: "comparison",
      pageId: "comparison"
    }), this.props.funds.length && uuid ? React.createElement(Datalayer, {
      id: "FundsComparison",
      type: "compareProducts",
      params: {
        id: uuid,
        funds: this.props.funds
      }
    }) : null, React.createElement(Container, null, React.createElement(FamilyInsideNavigation, {
      productType: productType,
      current: "comparison",
      context: {
        contextOrdered,
        getContextModelName,
        getContextModelPath
      }
    })), React.createElement(Container, null, React.createElement(ContainerInner, null, React.createElement(MainContent, {
      noMargin: true,
      fullWidth: true
    }, React.createElement(FundComparison, {
      storefront: contextStorefront ? contextStorefront.model.alias : '',
      user: this.props.user,
      productType: productType,
      funds: funds,
      shareTitle: shareTitle,
      shareUrl: shareUrl,
      onSave: this.handleSaveSearch,
      onRemoveProduct: this.handleRemoveProduct,
      onAddProduct: this.handleAddProduct,
      onSelectSession: this.handleSelectSession,
      userComparisons: userComparisons,
      comparisonsDialog: comparisonsDialog,
      onOpenUserComparisonsDialog: this.handleOpenUserComparisonsDialog,
      onCloseUserComparisonsDialog: this.handleCloseUserComparisonsDialog,
      isPartner: true
    }), ['plan', 'fund'].includes(productType.id) ? React.createElement(FundGettingStarted, {
      productType: productType,
      gettingStarted: gettingStarted
    }) : null))));
  }
}
export default withContext(connect(mapStateToProps, mapDispatchToProps)(withParams(withTheme(Comparison))));